<script>
import { LinkMposServices } from '@/services/nextshop/link.mpos.service'
import Swal from "sweetalert2"

export default {
  data() {
    return {
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentUser"))
    };
  },
  async created(){
    await this.getDataUrl()
    await this.removeLinkToAccount()
  },
  methods: {
    async getDataUrl(){
      const url = new URL(document.URL);
      const mposToken = url.searchParams.get("token")
      const mposMerchantId = url.searchParams.get("merchantId")

      if(mposToken != '' && mposToken != null && mposMerchantId != '' && mposMerchantId != null){
        this.setData('mposMerchantId', mposMerchantId)
        this.setData('mposToken', mposToken)
      }
    },
    async removeLinkToAccount(){
      const mposToken = this.getData("mposToken")
      const mposMerchantId = this.getData("mposMerchantId")

      if(mposToken != '' && mposToken != null && mposMerchantId != '' && mposMerchantId != null){
        const params = {
          configInfor: {
            posIds: ["mpos"],
            providerId: mposMerchantId,
            secretKey:  process.env.VUE_APP_SECRET_KEY_MPOS,
            sectionId: mposToken
          },
          isLink: false,
          merchantId: this.inforMerchant.merchantId,
          partnerType: "MPOS_TYPE"
        }

        const resData = await LinkMposServices.removeLinkToAccount(params)

        if(resData.success == false){
          if(resData.code == 'UNHANDLED_ERROR'){
            resData.message = 'Tài khoản đăng nhập để hủy không đúng.'
          }

          Swal.fire({
            icon: 'warning',
            title: 'Lỗi gỡ liên kết',
            html: resData.message,
            confirmButtonText: "Xác nhận",
          }).then(() => {
            this.$router.push({ path: "/setting/mpos-connect" });
          });
        }else{
          localStorage.removeItem("checkMposMerchantId")
          this.$router.push({ path: "/setting/mpos-connect-next" });
        }
      }
    },
    setData(key, value) {
      localStorage.setItem(key, value);
    },
    getData(key) {
      const data = localStorage.getItem(key);
      return data;
    }
  },
};
</script>

<template>
  <div>
    <Layout>

    </Layout>
  </div>
</template>
